import s from '../Styles/Loading.module.css'

export function Loading() {
  return (
    <div className={s.ldsRoller}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  );
}
